export default "__VITE_ASSET__97722196__"